export default __webpack_public_path__ + "f7c4122b7932402350ab464d593e4888.svg";